import { useEffect, useState } from "react";
import { trackContentView } from "../lib/track";
import { loadChunk } from "./chunks";
import FeaturePage from "./FeaturePage";
import ComparePage from "./ComparePage";
import ArticlePage from "./ArticlePage";
import ToolPage from "./ToolPage";
import HubPage from "./HubPage";

const TEMPLATES = {
  feature: FeaturePage,
  compare: ComparePage,
  tool: ToolPage,
  hub: HubPage,
};

/**
 * The route element for every content page.
 *
 * The template renders straight away from the registry entry, so the page
 * always has its h1 and the prerender never captures a blank. The chunk (body
 * html, FAQ, sources) arrives a moment later and fills in below it.
 */
export default function ContentRoute({ entry }) {
  const [loaded, setLoaded] = useState({ chunk: null, data: null });

  useEffect(() => {
    let live = true;
    loadChunk(entry.chunk)
      .then((data) => live && setLoaded({ chunk: entry.chunk, data }))
      .catch(() => live && setLoaded({ chunk: entry.chunk, data: null }));
    return () => {
      live = false;
    };
  }, [entry.chunk]);

  useEffect(() => {
    trackContentView(entry.type, entry.path, entry.lang);
  }, [entry.type, entry.path, entry.lang]);

  // Never show a previous page's body under a new page's heading.
  const chunk = loaded.chunk === entry.chunk ? loaded.data : null;
  const Template = TEMPLATES[entry.type] ?? ArticlePage;
  return <Template entry={entry} chunk={chunk} />;
}
